import { SchemaField } from '../../../legacy/objects/generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../../legacy/objects/generic/serialization/serializable-object-schema';
import { SessionURL } from '../../core/session-url/session-url';

export class DomMutationSelectionSchema extends SerializableObjectSchema {
  public static readonly url = 'url';
  public static readonly domMutationId = 'domMutationId';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters: { [key: string]: import('joi').AnySchema } = {};

    parameters[DomMutationSelectionSchema.url] = SchemaField.obj(SessionURL, undefined).required();
    parameters[DomMutationSelectionSchema.domMutationId] = SchemaField.autoGeneratedDocId(undefined).required();

    return parameters;
  }
}
